import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowRight } from 'lucide-react';
import { authAPI } from '../../services/api';
import Alert from '../common/Alert';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const result = await authAPI.forgotPassword(email);
    setLoading(false);
    if (result.success) setSent(true);
    else setError(result.message || 'Something went wrong. Please try again.');
  };

  return (
    <div className="max-w-md mx-auto py-8">
      <div className="mb-8">
        <Link to="/login" className="inline-flex items-center gap-2 text-sm font-medium text-ink-500 hover:text-ink-700">
          ← Back to sign in
        </Link>
        <h1 className="mt-6 text-3xl font-bold tracking-tight text-ink-900">Forgot password</h1>
        <p className="mt-2 text-sm text-ink-500">
          Enter your account email and we'll send you a reset link.
        </p>
      </div>

      {error && <Alert type="error" message={error} className="mb-5" />}

      {sent ? (
        <Alert
          type="success"
          title="Check your inbox"
          message="If an account exists for that email, a reset link is on its way. The link expires in 60 minutes."
        />
      ) : (
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-1.5">
            <label htmlFor="email" className="block text-sm font-medium text-ink-700">Email</label>
            <div className="relative">
              <Mail className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-ink-400" />
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="you@example.com"
                autoComplete="email"
                className="w-full rounded-lg border border-ink-200 bg-white pl-10 pr-3.5 py-2.5 text-sm text-ink-900 placeholder-ink-400 focus:outline-none focus:ring-4 focus:ring-brand-100 focus:border-brand-500"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            className="inline-flex w-full items-center justify-center gap-2 rounded-lg bg-ink-900 px-4 py-2.5 text-sm font-semibold text-white shadow-soft hover:bg-ink-800 transition disabled:opacity-60"
          >
            {loading ? 'Sending…' : 'Send reset link'}
            {!loading && <ArrowRight className="h-4 w-4" />}
          </button>
        </form>
      )}
    </div>
  );
};

export default ForgotPassword;
